import { ShipperDeliveryProposalDetailPage } from "@/pages/shipper-delivery-proposal-detail";
import { createFileRoute, useParams } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_auth_requeired/shipper/delivery-proposals/$id/",
)({
  component: () => {
    const { id } = useParams({ strict: false });
    return <ShipperDeliveryProposalDetailPage deliveryProposalId={id} />;
  },
});
